export default __webpack_public_path__ + "static/media/Deo-Attraction.4a3eb7af.jpg";